import { ProForm } from "@ant-design/pro-components";
import { Image } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  CustomButton,
  CustomCard,
  CustomInput,
  CustomRadio,
  toast,
} from "../../../../../../components";
import { useMobile } from "../../../../../../context/MobileContext";
import { useModal } from "../../../../../../context/ModalContext";
import { channelEnum } from "../../../../../../enumerations/channelEnum";
import { apiCodeEnum } from "../../../../../../enumerations/signInUpEnum";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { checkInputHasNull, envChangeType, reset } from "../../../../../../plugins/utils";
import { useGetPayCaseUrl, usePostRecharge } from "../../../../hooks/index.hook";
import ChannelRadio from "../../../ChannelRadio";
import SettingArea from "../../../SettingArea";
import styles from "./style.module.scss";
import "./style.scss";

const Recharge = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const { isMobile } = useMobile();
  const { openTipsModal } = useModal();
  const [methods, setMethods] = useState([]);
  const [methodsValue, setMethodsValue] = useState();
  const [quickAmount, seQuickAmount] = useState([]);
  const [quickAmountValue, setQuickAmountValue] = useState();
  const [disabled, setDisabled] = useState(true);
  const [currentAmount, setCurrentAmount] = useState(0);
  const [targetChain, setTargetChain] = useState({});

  const { mutate: recharge, isLoading } = usePostRecharge();
  const { refetch, isFetching } = useGetPayCaseUrl({ enabled: false });

  const settingEnum = [
    {
      label: t("label.limit"),
      value: t("wallet.recharge.limit", {
        min: moneyFormat(data?.min_money || 0),
        max: moneyFormat(9999999),
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
      }),
    },
    // {
    //   label: t("label.handlingFee"),
    //   value: `${0}%`,
    // },
    {
      label: t("label.payable"),
      value: `${currentAmount} ${t(
        `currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`,
      )}`,
    },
    {
      label: t("label.conversionRate"),
      value: t("wallet.recharge.rate", {
        rate: targetChain?.ratio,
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
        transformCurrency: targetChain?.name,
      }),
    },
    {
      label: `≈ ${targetChain?.name}`,
      value: moneyFormat(currentAmount * targetChain?.ratio, 6, 6),
    },
  ];

  const handleChangeInput = (value = 0) => {
    checkInputHasNull(formRef, setDisabled);
    setCurrentAmount(value);
  };

  const handleClickQuickAmount = (e) => {
    setQuickAmountValue(e.target.value);
    formRef.current.setFieldValue("number", Number(e.target.value));
    setCurrentAmount(Number(e.target.value));
    checkInputHasNull(formRef, setDisabled);
  };

  const handleClickTutorial = () => {
    // refetch().then((res) => (window.location.href = res?.data[0]));
    window.location.href = "/tutorial";
  };

  const handleFinish = () => {
    const params = formRef.current.getFieldsValue();
    const form = new FormData();
    form.append("cid", methodsValue);
    form.append("number", params.number);

    recharge(
      {
        params: form,
      },
      {
        onSuccess: (success) => {
          const { code, msg, data } = success?.data;
          if (code === apiCodeEnum.ERROR) {
            openTipsModal({
              body: msg,
            });
            return;
          }
          toast({ content: msg, type: "success" });
          reset(formRef);
          switch (data?.type) {
            case 1:
              navigate(`/user/recharge/recharge/${data?.sn}`, { state: data, replace: true });
              return;
            case 2:
              window.location.href = data?.url;
              return;
            default:
              return;
          }
        },
        onError: () => {},
      },
    );
  };

  useEffect(() => {
    if (!data) return;
    console.log(data);
    let newMethods = [];
    let newQuickAmount = [];
    data.data.map((item) => {
      newMethods.push({
        value: item?.cid,
        text: (
          <div className="content-container">
            {item?.logo ? (
              <Image
                src={envChangeType("REACT_APP_MOBILE_URL") + item?.logo}
                alt="logo"
                preview={false}
                className="img"
              />
            ) : (
              <img src={channelEnum[item.name]?.src} alt="logo" className="img" />
            )}
            <div>{item?.name}</div>
          </div>
        ),
        ratio: item?.ratio,
        name: item?.name,
      });
      return item;
    });
    data.num.map((item) => {
      newQuickAmount.push({ value: item, text: item });
      return item;
    });
    setMethods(newMethods);
    setMethodsValue(newMethods[0].value);
    seQuickAmount(newQuickAmount);
    setQuickAmountValue(newQuickAmount[0].value);
  }, [data]);

  useEffect(() => {
    if (methods.length <= 0 || !methodsValue) return;
    const newTargetChain = methods.filter((item) => item.value === methodsValue)[0];
    setTargetChain(newTargetChain);
  }, [methods, methodsValue]);

  return (
    <div className={styles.recharge}>
      <CustomCard>
        <ProForm
          formRef={formRef}
          onFinish={handleFinish}
          submitter={false}
          className="recharge-from"
        >
          <ChannelRadio
            methods={methods}
            methodsValue={methodsValue}
            setMethodsValue={setMethodsValue}
            className="custom-channel-radio-style"
          />
          <div className="input-container">
            <CustomInput
              label={t("label.rechargeAmount")}
              name="number"
              placeholder={t("normal.pleaseEnter", { label: t("label.rechargeAmount") })}
              type="number"
              onChange={handleChangeInput}
            />
            {!isMobile && (
              <CustomButton
                buttonStyle={`${styles.customButtonStyle}`}
                type={"submit"}
                disabled={disabled}
                loading={isLoading}
              >
                {t("normal.next").toUpperCase()}
              </CustomButton>
            )}
          </div>
          <div className={`quick-amount-radio`}>
            <CustomRadio
              items={quickAmount}
              value={quickAmountValue}
              onClick={handleClickQuickAmount}
              type="radio"
            />
          </div>
          {isMobile && (
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              type={"submit"}
              disabled={disabled}
              loading={isLoading}
            >
              {t("normal.determine.upper")}
            </CustomButton>
          )}
        </ProForm>
        <SettingArea settingEnum={settingEnum} />
      </CustomCard>
      <div style={{ margin: isMobile ? 6 : 44 }} />
      <CustomCard>
        <CustomButton
          buttonStyle={`${styles.tutorialCustomButtonStyle}`}
          onClick={handleClickTutorial}
          loading={isFetching}
        >
          {t("wallet.recharge.tutorial")}
        </CustomButton>
        <div
          className={styles.hint}
          dangerouslySetInnerHTML={{
            __html: t("wallet.recharge.hint", {
              currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
              min: data?.min_money,
            }),
          }}
        />
      </CustomCard>
    </div>
  );
};

export default Recharge;
